import { Tag } from './tag';
import { TagCategoryType } from './tag-category-type';

export class TagCategory {
	public id: number;
	public name: string;
	public tagCategoryTypeId: number;
	public isRequired: boolean;
	public canHaveMultiple: boolean;
	public sortOrder: number;
	public useTagBox: boolean;
	public dependentTagCategoryId: number;

	public tagCategoryType: TagCategoryType;
	public tags: Tag[];

	constructor(tagCategory: TagCategory) {
		Object.assign(this, tagCategory);

		this.tagCategoryType = tagCategory.tagCategoryType ? new TagCategoryType(tagCategory.tagCategoryType) : tagCategory.tagCategoryType;
		this.tags = tagCategory.tags ? tagCategory.tags.map((t: Tag) => new Tag(t)) : tagCategory.tags;
	}
}
